import { useRouter } from "next/router";
import React from "react";

import Checkbox from "@components/UI/Checkbox";
import FormattedMessage from "@components/UI/FormattedMessage";

import {
  getNewCheckboxFilterValue,
  parseMealOptionsQueryParam,
} from "./helpers";

interface Props {
  query: any;
  mealOptions: { label: string; value: string }[];
  mealOptionCounts: Record<string, number>;
}

const FilterBoxAccommodationType = ({
  query,
  mealOptions,
  mealOptionCounts,
}: Props) => {
  const router = useRouter();

  const changeCheckboxFilter = (key: string, code: string) => {
    router.push(
      {
        pathname: router.pathname,
        query: {
          ...getNewCheckboxFilterValue(query, key, code),
        },
      },
      undefined,
      { scroll: false }
    );
  };

  const selectedMealOptions = parseMealOptionsQueryParam(query.mealOption);

  return (
    <div className="filters-box" id="filter-accommodation-type">
      <span className="filters-label">
        <FormattedMessage id="Filters.accommodationType" />:
      </span>

      {mealOptions.map((option, index) => (
        <div key={index} className="filter-stars-checkbox">
          <Checkbox
            key={option.value}
            customContainerClass="filter-airline-checkbox-container"
            customLabelClass="filter-airline-checkbox-label"
            id={`filter-meal-${option.value}`}
            label={option.label}
            onClick={() => {
              changeCheckboxFilter("mealOption", option.value);
            }}
            checked={selectedMealOptions.includes(option.value)}
          />
          <span>{mealOptionCounts[option.value] || 0}</span>
        </div>
      ))}
    </div>
  );
};

export default FilterBoxAccommodationType;
